import ViewBase from "../../../../framework/core/mvvm/view_base";
import AppData from "../../../public/const/app_data";

const { ccclass, property } = cc._decorator;

@ccclass
export default class TestView extends ViewBase {




  @property(cc.Label)
  text: cc.Label = null;

  @property(cc.Sprite)
  sprite: cc.Sprite = null;

  @property(cc.EditBox)

  editBox: cc.EditBox = null;

  @property(cc.Node)
  testNode: cc.Node = null;
  @property(cc.Node)
  nullNode: cc.Node = null;
  @property(cc.Node)
  verifyNode: cc.Node = null;

  @property(cc.Node)
  demoNode: cc.Node = null;

  @property(cc.Node)
  serverNode: cc.Node = null;
  @property(cc.Node)
  messageNode: cc.Node = null;

  @property(cc.Label)
  serverLabel: cc.Label = null;
  @property(cc.Label)
  serverUrlLabel: cc.Label = null;

  @property(cc.EditBox)
  verifyBox: cc.EditBox = null;
  @property(cc.EditBox)
  serverBox: cc.EditBox = null;


  @property(cc.Node)
  buglyTestNode:cc.Node = null;

  @property(cc.Node)
  googleBillingNode:cc.Node = null;
  @property(cc.EditBox)
  skuIdBox: cc.EditBox = null;

}
